export default __webpack_public_path__ + "static/media/turncamera.8370104b.svg";